export default __webpack_public_path__ + "static/media/cpv_30_office-machine.147d76ea.svg";